<template>
    <div>
    <h2>Transcribe</h2>
        <b-container fluid align-content="center">
                <b-tabs class="my-4">
                    <b-tab title="Upload files"
                    class="ml-5"
                    :to="'/translate/docs'"
                    @click='openRoute("/translate/docs")'>
                        <template v-slot:title>
                            <b-icon icon="upload"></b-icon> Upload
                        </template>
                    </b-tab>
                </b-tabs>
        </b-container>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  methods: {
    openRoute (x) {
      if (this.$route.path !== x) { this.$router.push(x) }
    }
  },
  mounted () {
    if (this.$route.path !== '/transcribe/files') this.$router.push('/transcribe/files').catch(() => {})
  }
}

</script>

<style scoped>

</style>
